module.exports = __webpack_public_path__ + "img/terminal_bg.aa995ee2.png";